/* aether — countdown del drop. Ogni [data-ae-countdown="ISO"] mostra [data-ae-before] prima e [data-ae-after] dopo. */
(function () {
  'use strict';
  if (window.__aetherDrop) return;
  window.__aetherDrop = true;
  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function init(ctx) {
    var roots = qa('[data-ae-countdown]', ctx);
    if (ctx && ctx.hasAttribute && ctx.hasAttribute('data-ae-countdown')) roots.push(ctx);
    roots.forEach(function (el) {
      if (el.__aeCd) return;
      el.__aeCd = true;
      var target = Date.parse(el.getAttribute('data-ae-countdown'));
      if (isNaN(target)) return;
      var timer = null;
      function set(unit, value) { qa('[data-ae-cd="' + unit + '"]', el).forEach(function (n) { n.textContent = value; }); }
      function tick() {
        var diff = target - Date.now();
        var live = diff <= 0;
        qa('[data-ae-before]', el).forEach(function (n) { n.hidden = live; });
        qa('[data-ae-after]', el).forEach(function (n) { n.hidden = !live; });
        if (live) { if (timer) clearInterval(timer); return; }
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600;
        var m = Math.floor(s / 60); s -= m * 60;
        set('d', d); set('h', pad(h)); set('m', pad(m)); set('s', pad(s));
        set('hh', pad(h + d * 24));
        qa('[data-ae-cd-days]', el).forEach(function (n) { n.hidden = d === 0; });
      }
      tick();
      timer = setInterval(tick, 1000);
    });
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();